import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { AutoComplete } from '../../../../../../../components'
import { isEqual } from 'lodash'

/**
 * Contact Job Address: Form Component
 */
class Address extends Component {

  /**
   * ComponentDidMount
   */
  componentDidMount () {
    const { job, onValueChange } = this.props
    const address = (job && job._id && this.getAddress(job)) || null

    onValueChange(address && address.value)
  }

  /**
   * ComponentDidUpdate
   * @param prevProps
   */
  componentDidUpdate (prevProps) {
    const { institution, options, onValueChange } = this.props

    if ((prevProps.institution !== institution && !institution) || (prevProps.options.length && !isEqual(prevProps.options, options))) {
      onValueChange(null)
    }
  }

  /**
   * Get address options
   * @returns {*}
   */
  getAddressOptions = () => {
    const { options } = this.props

    if (!options || (Array.isArray(options) && options.every((option) => !option))) {
      return
    }

    return []
      .concat(options || []).map((option) => {
        return {
          label: this.getLabel(option),
          value: this.getValue(option)
        }
      })
  }

  /**
   * Prepopulate Address on Edit
   * @param address
   * @returns {*}
   */
  getAddress = (address) => {
    return (address ? {
      label: this.getLabel(address),
      value: this.getValue(address)
    } : null)
  }

  /**
   * Get address label
   * @param value
   * @returns {{label: string}}
   */
  getLabel = (value) => {
    const address = []
      .concat(value.address1, value.address2, value.address3)
      .filter((value) => value && value.trim()).join(' ')

    return ([]
      .concat(address, value.city, value.state_province, value.country_name, value.postal_code)
      .filter((value) => value && value.trim()).join(', '))
  }

  /**
   * Get address value
   * @param value
   * @returns {*}
   */
  getValue = (value) => {
    return {
      address1: value.address1,
      address2: value.address2,
      address3: value.address3,
      city: value.city,
      state_province: value.state_province,
      postal_code: value.postal_code,
      city_state_zip: []
        .concat(value.city, value.state, value.zip)
        .filter((value) => value && value.trim()).join(', '),
      country: value.country,
      country_name: value.country_name,
      region: value.region,
      phone: value.telephone || value.phone,
      fax: value.fax
    }
  }

  /**
   * Render
   * @return {XML}
   */
  render () {
    const { address, onValueChange } = this.props
    const options = this.getAddressOptions() || []

    return (
      <div className='field'>
        <label className='field_label'>Select Address</label>
        <AutoComplete
          name='address'
          showDropdownIndicator={false}
          value={this.getAddress(address)}
          options={options}
          onChange={(option) => onValueChange(option && option.value)}/>
      </div>
    )
  }
}

Address.propTypes = {
  job: PropTypes.object,
  address: PropTypes.object,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onValueChange: PropTypes.func.isRequired
}

Address.defaultProps = {
  options: []
}

export default Address